import {
  DELETE_FILE,
  DELETE_FILE_ERROR,
  DELETE_FILE_SUCCESS,
  RESET_FILE_UPLOAD,
  UPLOAD_FILE,
  UPLOAD_FILE_ERROR,
  UPLOAD_FILE_SUCCESS,
} from "../constants";

interface FileUploadState {
  uploadedFilePath: string | null;
  isUploading: boolean;
  isDeleting: boolean;
  error: string | null;
}

const initialState: FileUploadState = {
  uploadedFilePath: null,
  isUploading: false,
  isDeleting: false,
  error: null,
};

export const fileUpload = (
  state: FileUploadState = initialState,
  action: any,
) => {
  switch (action.type) {
    case UPLOAD_FILE:
      return {
        ...state,
        isUploading: true,
        error: null,
      };

    case UPLOAD_FILE_SUCCESS:
      return {
        ...state,
        uploadedFilePath: action.payload.filePath,
        isUploading: false,
        error: null,
      };

    case UPLOAD_FILE_ERROR:
      return {
        ...state,
        isUploading: false,
        error: action.payload.error,
      };

    case DELETE_FILE:
      return {
        ...state,
        isDeleting: true,
        error: null,
      };

    case DELETE_FILE_SUCCESS:
      return {
        ...state,
        uploadedFilePath: null,
        isDeleting: false,
        error: null,
      };

    case DELETE_FILE_ERROR:
      return {
        ...state,
        isDeleting: false,
        error: action.payload.error,
      };

    case RESET_FILE_UPLOAD:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};
